import { ModalOverlay } from '@mantine/core';
import { PISANO_COLORS } from '../../colors';

export const ModalOverlayConfig = ModalOverlay.extend({
  defaultProps: {
    color: PISANO_COLORS.dark[5],
    opacity: 0.5,
  },
});
